/* Keep third-party quick-view product titles consistent with storefront cards. */
(() => {
  'use strict';

  const selector = '.ecom-product__heading';

  const cleanTitle = (element) => {
    if (!(element instanceof HTMLElement) || element.dataset.zalvaroTitleCleaned === 'true') return;

    const original = element.textContent.trim();
    const cleaned = original.replace(/^zalvaro\s+/i, '').trim();
    if (cleaned) element.textContent = cleaned;
    element.dataset.zalvaroTitleCleaned = 'true';
  };

  const cleanWithin = (root) => {
    if (!(root instanceof Element || root instanceof Document)) return;
    if (root instanceof Element && root.matches(selector)) cleanTitle(root);
    root.querySelectorAll(selector).forEach(cleanTitle);
  };

  const start = () => {
    cleanWithin(document);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) cleanWithin(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
